import { selectActiveAdditionalIds } from '../publishTerms';
import { createSelector } from 'reselect';
import { selectPublishTerms } from '../publishTerms/selectPublishTerms';

const replaceHighlightWithColor = (str: string) => str.replace('highlight', 'color');

export const selectAnalyticsVariant = createSelector(
  [selectPublishTerms, selectActiveAdditionalIds],
  ({ selectedServiceId }, additionals): string | undefined => {
    if (!selectedServiceId) {
      return undefined;
    }

    const serviceIds = [...selectedServiceId.split('+'), ...additionals];

    return serviceIds.map(replaceHighlightWithColor).join('/');
  },
);
